import BaseAPI from '@/apis/base/baseApi';

class RoleAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'role';
}

export default new RoleAPI();
